/**
 * Merges an object with the previous state object. Checks if any other fields at the top level have
 * actually changed. If none of the fields are changed the oldState will be set to avoid a rerender
 * 
 * @param {() => {}} setter 
 * @param {{
 *  [key: string]: any,
 * }} newState
 */
const mergeState = (setter, newState) => {
  setter(prevState => {
    const mergeState = {...prevState};
    let changed = false;

    for (const [ key, value ] of Object.entries(newState)) {
      mergeState[key] = value;
      changed ||= prevState[key] !== value;
    }

    return changed ? mergeState : prevState;
  });
}

export {
  mergeState,
}